/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordingWestburyContributionsInner
 */
export interface RecordingWestburyContributionsInner {
    /**
     * 
     * @type {string}
     * @memberof RecordingWestburyContributionsInner
     */
    contribution: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecordingWestburyContributionsInner
     */
    isRecordingContribution?: boolean | null;
}

/**
 * Check if a given object implements the RecordingWestburyContributionsInner interface.
 */
export function instanceOfRecordingWestburyContributionsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;

    return isInstance;
}

export function RecordingWestburyContributionsInnerFromJSON(json: any): RecordingWestburyContributionsInner {
    return RecordingWestburyContributionsInnerFromJSONTyped(json, false);
}

export function RecordingWestburyContributionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingWestburyContributionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contribution': json['contribution'],
        'isRecordingContribution': !exists(json, 'isRecordingContribution') ? undefined : json['isRecordingContribution'],
    };
}

export function RecordingWestburyContributionsInnerToJSON(value?: RecordingWestburyContributionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contribution': value.contribution,
        'isRecordingContribution': value.isRecordingContribution,
    };
}

